import axios from "axios";
import { api } from "./api";

export const fileUpload = async (file: File, uploadType: string, user: any) => {
  const uploadPayload = {
    fileName: file.name,
    uploadType,
    mimeType: file.type,
    id: user?.id,
  };
  const data = await api.getFileUpload(uploadPayload);

  console.log(data);

  const response = await axios.put(data.uploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
  return { response, url: data.uploadUrl.split("?")[0] };
};
